module.exports = __webpack_public_path__ + "static/cart05-101031a4e3532309df378ed7e397b119.svg";